export const G = {
  g900:"#04342C", g800:"#085041", g700:"#0F6E56", g600:"#1D9E75",
  g400:"#5DCAA5", g100:"#E1F5EE",
  amber:"#EF9F27", amberBg:"#FAEEDA",
  gray6:"#5F5E5A", gray8:"#444441",
};
